import axios from 'axios'
import { getAppEndpointVersion } from 'helpers'
import constants from '../constants'

export default function init() {
  console.log('groups init')
}

export async function list(app, apiHost, pageNo = 1, searchText = '') {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups?per_page=${
    constants.perPageInListings
  }&page=${pageNo}&searchKey=${searchText}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      if (error && error.response && error.response.data) return error.response.data
      // else
      return false
      // return error.response.data;
    })
}

export async function add(post, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups`
  return axios
    .post(`${URL}`, post, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function get(id, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups/${id}`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function update(id, post, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups/${id}`
  return axios
    .put(`${URL}`, post, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function del(id, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups/${id}`
  return axios
    .delete(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function search(app, apiHost, searchText, pageNo = 1) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups?searchKey=${searchText}&per_page=${
    constants.perPageInListings
  }&page=${pageNo}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function members(id, app, apiHost, pageNo = 1, searchText = '') {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups/${id}/members?per_page=${
    constants.perPageInListings
  }&page=${pageNo}&searchKey=${searchText}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function searchMembers(id, searchText, app, apiHost, pageNo = 1) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(
    app,
  )}/groups/${id}/members?searchKey=${searchText}&per_page=${
    constants.perPageInListings
  }&page=${pageNo}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function kickMember(uid, guid, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups/${guid}/members/${uid}`
  return axios
    .delete(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function banMember(uid, guid, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups/${guid}/bannedusers/${uid}`
  return axios
    .post(
      `${URL}`,
      {},
      {
        headers: {
          appId: app.id,
          apiKey: app.accessKey,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      },
    )
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function unbanMember(uid, guid, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups/${guid}/bannedusers/${uid}`
  return axios
    .delete(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function getBanMembers(guid, app, apiHost, pageNo = 1, searchText = '') {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups/${guid}/bannedusers?per_page=${
    constants.perPageInListings
  }&page=${pageNo}&searchKey=${searchText}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function searchBanMembers(guid, searchText, app, apiHost, pageNo = 1) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(
    app,
  )}/groups/${guid}/bannedusers?searchKey=${searchText}&per_page=${
    constants.perPageInListings
  }&page=${pageNo}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function addMembers(uids, guid, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/groups/${guid}/members`
  return axios
    .post(
      `${URL}`,
      { participants: uids },
      {
        headers: {
          appId: app.id,
          apiKey: app.accessKey,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      },
    )
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}
